<template>
  <button
    ref="refButtonScreen"
    class="button-white button-icon button-icon-bigger button-rounded"
    @click="onClickButtonScreen"
    :class="{ active: isVisibleScreen }"
  >
    <IconScreen class="icon-medium" />
  </button>
  <DropdownModeNavigator
    v-if="isVisibleScreen"
    mode="screen"
    :target-el="refButtonScreen"
    @close="closeDropdownScreen"
  />
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';

import DropdownModeNavigator from '@/components/domains/chat/common/DropdownModeNavigator.vue';
import IconScreen from '@/components/icons/IconScreen.vue';

const refButtonScreen = useTemplateRef('refButtonScreen');
const isVisibleScreen = ref<boolean>(false);

const openDropdownScreen = () => {
  isVisibleScreen.value = true;
};

const closeDropdownScreen = () => {
  isVisibleScreen.value = false;
};

const onClickButtonScreen = () => {
  if (isVisibleScreen.value) {
    closeDropdownScreen();
  } else {
    openDropdownScreen();
  }
};
</script>

<style scoped lang="scss"></style>
